import { useDiscardAbandonedOAuthSignIn } from '@/modules/credentials';

import { useConnectOnOAuthReturn } from '../hooks/use-connect-on-oauth-return';

/**
 * Mounts {@link useConnectOnOAuthReturn} and the cleanup of sign-ins the user
 * backed out of; renders nothing.
 */
export function ConnectOnOAuthReturn() {
  useConnectOnOAuthReturn();
  useDiscardAbandonedOAuthSignIn();
  return null;
}
